/**
 * OrderOrigin — the closed two-value vocabulary naming what created an order:
 * a buyer's own checkout (`sale`, priced or free) or a member's guest issuance
 * (`guest`).
 * `order.entity.ts` writes it once, at the order's birth; `ticket.entity.ts`
 * carries a copy stamped onto each ticket at mint, because the door reads
 * tickets and holds no read path to the order.
 *
 * The vocabulary sits in its own file rather than on either entity because
 * `order.entity.ts` imports the VALUE `SecretToken` from `ticket.entity.ts`
 * and evaluates it at module scope; an edge back the other way closes a
 * load-time cycle that throws whichever order the barrel resolves the two in.
 * This file imports zod and nothing else — no `*.entity.ts` import may enter
 * it.
 */
import { z } from "zod";

// The closed set of things that can create an order — a third value is an
// explicit amendment to this enum, never an open "any future origin" clause.
export const OrderOriginSchema = z.enum(["sale", "guest"]);
export type OrderOrigin = z.infer<typeof OrderOriginSchema>;
